import { render } from "./newLeadModal.vue?vue&type=template&id=78e957b2&ts=true"
import script from "./newLeadModal.vue?vue&type=script&lang=ts"
export * from "./newLeadModal.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__